/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Which tier of the reward catalog a reward belongs to. PLATFORM — curated by god-admin, offered to every workspace. PARTNER — authored by/for one brand, visible only in that brand's workspace. Absent reads as PLATFORM (pre-tiering rows were platform-authored).
 * @export
 */
export const RewardProviderTier = {
    PLATFORM: 'PLATFORM',
    PARTNER: 'PARTNER'
} as const;
export type RewardProviderTier = typeof RewardProviderTier[keyof typeof RewardProviderTier];


export function instanceOfRewardProviderTier(value: any): boolean {
    for (const key in RewardProviderTier) {
        if (Object.prototype.hasOwnProperty.call(RewardProviderTier, key)) {
            if (RewardProviderTier[key as keyof typeof RewardProviderTier] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RewardProviderTierFromJSON(json: any): RewardProviderTier {
    return RewardProviderTierFromJSONTyped(json, false);
}

export function RewardProviderTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardProviderTier {
    return json as RewardProviderTier;
}

export function RewardProviderTierToJSON(value?: RewardProviderTier | null): any {
    return value as any;
}

export function RewardProviderTierToJSONTyped(value: any, ignoreDiscriminator: boolean): RewardProviderTier {
    return value as RewardProviderTier;
}

